package com.dignicate.web.data.content.static.home

import com.dignicate.web.data.content.AboutContentDto
import com.dignicate.web.domain.Language
import com.dignicate.web.domain.LocalizedText
import com.dignicate.web.domain.LocalizedTexts

class AboutContentSource {
    fun about(): AboutContentDto {
        return AboutContentDto(
            body = LocalizedTexts(
                listOf(
                    LocalizedText(
                        Language.Ja,
                        "ディグニケート（Dignicate, LLC）は、スマートフォンアプリ開発を中心とした小さなソフトウェアスタジオです。2019年の設立以来、Android / iOS 向けのモバイルアプリを主軸に、Kotlin Multiplatform や Flutter を使ったクロスプラットフォーム開発に取り組んできました。\n\nクライアントワークでは、新規サービスの立ち上げから既存アプリの改修・リプレースまで、アーキテクチャ設計・UI実装・ストア公開・運用フェーズの改善を含めて、モバイル領域をまとめてお手伝いしています。\n\n大きな組織ではありませんが、その分、開発者本人と直接やりとりしながら、現実的で長く使えるソフトウェアを一緒に作っていきます。"
                    ),
                    LocalizedText(
                        Language.En,
                        "Dignicate, LLC is a small software studio focused on mobile application development. Since 2019, we have been building Android and iOS apps, exploring Kotlin Multiplatform and Flutter to support multiple platforms with a consistent architecture.\n\nFor client work, we help launch new products and improve existing apps — covering architecture design, implementation, store releases, and ongoing improvements in the mobile area.\n\nWe work in a small, direct setup where you can talk to the developer in charge and build realistic, long-living software together."
                    )
                )
            )
        )
    }
}
